import styled from "styled-components";
import eyeWhite from "../../images/eyeWhite.svg";
import eyeBlue from "../../images/eyeBlue.svg";
import refreshIcon from "../../images/C_refresh.svg";
import moreIcon from "../../images/C_moree.svg";  
import updateBlue from "../../images/C_updatee.svg";
import optionsBlue from "../../images/C_optionn.svg"
import fileBlue from "../../images/file_icon_blue.svg";
import fileWhite from "../../images/file_icon_white.svg";

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  border: 1px solid #ADB8AE;
  border-radius: 8px;
  background-color: #ffffff;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh);
  margin-top: 0;
  padding: 18px;
  overflow: auto;
`;
export const TableWrap = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-bottom: none;
  border-radius: 8px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
`;
export const MainTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  & th {
    height: 52px;
    background: #F2F6F8;
    font-weight: 700;
    padding: 4px 30px;
    text-align: left;
    font-weight:700px;
    font-size:12px;
    white-space: nowrap;
    &:first-child {
      border-top-left-radius: 8px;
    }
    &:last-child {
      border-top-right-radius: 8px;
    }
  }
  & tr {
    border: 1px solid #dfe9ef;
  }
  & td {
    height: 52px;
    border-bottom: 1px solid #dfe9ef;
    margin: 0px;
    padding: 4px 30px;
    font-weight:400;
    font-size:14px;
    line-height:16.51px;
    white-space: nowrap;
  }
`;
export const SortByButton = styled.button`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0px 14px 0px 0px;
  font-weight: 700;
  white-space: nowrap;

  &::before {
    content: '';
    height: 0px;
    width: 0px;
    position: absolute;
    right: 0px;
    margin-bottom: 8px;
    border-bottom: 5px solid ${({ sortBy, sortType }) => sortBy && sortType === 'asc' ? '#118D8B' : '#000000'};
    border-top: 0px solid transparent;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }
  &::after {
    content: '';
    height: 0px;
    width: 0px;
    position: absolute;
    right: 0px;
    margin-top: 8px;
    border-top: 5px solid ${({ sortBy, sortType }) => sortBy && sortType === 'desc' ? '#118D8B' : '#000000'};
    border-bottom: 0px solid transparent;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 5px;
  }
`;
export const ActionsWrapDiv = styled.div`
  display: flex;
  align-items: center;
`;
export const ActionButton = styled.button`
  height: 36px;
  width: 36px;
  padding: 8px;
  border-radius: 3px;
  background: none;
  &:hover {
    background-color: #f1f1f1;
  }
  & img {
    width: 20px;
    height: 20px;
  }
`;
export const PaginationWrapDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
`;
export const EntriesDiv = styled.div`
  display: flex;
  align-items: center;
`;
export const NoDataDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: 15px;
  & > img {
    height: 80px;
    width: 80px;
  }
  & > div {
    font-size: 20px;
    font-weight: 700;
    margin: 16px 0px 0px 0px;
  }
`;
export const LoadingDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`;
export const LoaderDiv = styled.div`
  border: 6px solid #118D8B;
  border-radius: 50%;
  border-top: 6px solid #f3f3f3;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
  margin-bottom: 12px;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
export const TableDropdownDiv = styled.div`
  display: flex;
  align-items: center;
`;
export const SingleLineP = styled.p`
  max-width: 200px;
  margin: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
export const StatusDiv = styled.div`
  background-color: ${({ status }) => status === 'Failed' ? '#DB1616' : '#C4DEDE'};
  color: ${({ status }) => status === 'Failed' ? '#ffffff' : '#000000'};
  font-size: 14px;
  padding: 10px;
  border-radius: 20px;
  text-align: center;
`;


export const IconDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  & button , img {
    border-radius: 6px;
  }
`;
export const ViewButton = styled.button`
  height: 32px;
  width: 32px;

    &:after {
        content: url(${eyeWhite});
        display: block;
        height: 32px;
        width: 32px; 
    }
    &:hover {
        &:after {
            content: url('${eyeBlue}');
            display: block;
            height: 32px;
            width: 32px;
        }
    }
   
`;

export const UpdateButton = styled.button`
  height: 32px;
  width: 32px;

    &:after {
        content: url(${refreshIcon});
        display: block;
        height: 32px;
        width: 32px; 
    }
    &:hover {
        &:after {
            content: url('${updateBlue}');
            display: block;
            height: 32px;
            width: 32px;
        }
    }
   
`;

export const OptionButton = styled.button`
  height: 32px;
  width: 32px;

    &:after {
        content: url(${moreIcon});
        display: block;
        height: 32px;
        width: 32px; 
    }
    &:hover {
        &:after {
            content: url('${optionsBlue}');
            display: block;
            height: 32px;
            width: 32px;
        }
    }
   
`;

export const MiscFileButton = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #DEE2EF;
  border-radius: 6px;

  &:after {
    content: "";
    display: block;
    height: 25px;
    width: 25px;
    background-image: url(${fileBlue});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  &:hover {
    background-color: #1B49EA;

    &:after {
      content: "";
      display: block;
      height: 25px;
      width: 25px;
      background-image: url(${fileWhite});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
`;

export const PaginationDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end; 
  border: 1px solid #D0D5DD;
  background-color: #ffffff;
  border-radius: 6px;
  overflow: hidden;
  height: 40px;
  margin-top: 16px; /* Adjust this value as needed */
  width: fit-content; /* Make sure the width fits the content */
  
  & button {
    height: 40px;
    min-width: 40px;
    padding: 8px;
    border: none;
    background: none;
    font-size: 14px;
    border-right: 1px solid #D0D5DD;
  }

  & div {
    height: 40px;
    min-width: 40px;
    padding: 8px;
    border: none;
    background: none;
    font-size: 14px;
    text-align: center;
    border-right: 1px solid #D0D5DD;
  }

  & button:hover {
    background: #F9FAFB;
  }

  & button:last-child {
    border: none;
  }
`;
export const PaginationButton = styled.button`
  color: ${({ active }) => active ? '#1B49EA' : '#344054'} !important;
  background: ${({ active }) => active ? '#F9FAFB' : 'none'} !important;

`;
export const ParentContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Aligns child to the right */
  padding: 16px; /* Optional: Add padding if needed */
`;

export const DropdownDiv = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  ul {
    list-style-type: none;
    margin: 0;
    padding: 10px;
  }
  li {
    padding: 5px 10px;
    cursor: pointer;
    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

export const TopContainer = styled.div`
  display:flex;
  justify-content:space-between;
   margin-top:10px;
  margin-bottom:20px;
  
  .leftSide {
  width:217px;
  height:29px;
  font-weight:700;
  font-size:20px;
  line-height:29.05px;
  color:#1E2228;
 
  }
  .rightSide {
  display:flex;
  gap:10px;
    & button{
     width:126px;
     height:35px;
     background-color:#1B49EA;
     color:#ffffff;
     border-radius:6px
    }
  }

`;


/* ------------------ Assessment Styles ------------------ */
export const AssessmentCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

`;

export const AssessmentInfo = styled.div`
  flex: 1;
`;

/* ------------------ Modal Styles ------------------ */
export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  gap: 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
  border: 1px solid rgba(239, 239, 240, 1);
`;

/* ------------------ Heading Styles ------------------ */
export const Heading = styled.h1`
  font-family: 'Basis Grotesque Pro', sans-serif;
  width: 320px;
  height: 21px;
  top: 705px;
  left: 215px;
  gap: 0px;
  opacity: 0px;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  text-align: left;
  color: rgba(255, 44, 145, 1);
`;

export const HeadingDescription = styled.p`
  font-family: 'Basis Grotesque Pro', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(147, 149, 153, 1);
`;

/* ------------------ Profile Styles ------------------ */
export const Profile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProfileHeader = styled.div`
  width: 200px;
  height: 200px;
  gap: 0px;
  border: 4px 0px 0px 0px;
  opacity: 0px;
`;

export const ProfileImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
`;

export const ProfileInitials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #333;
  font-size: 32px;
  font-weight: bold;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: center;

  p {
    text-align: center;
    gap: 2rem;
  }

  h2 {
    margin: 1px 0;
  }
`;

export const ProfileButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

export const Button = styled.button`
  height: 40px;
  width: 80px;
  display: flex;
  flex-direction: row;
  margin: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 550;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.6;
  }
`;

export const ApproveButton = styled(Button)`
  background-color: rgba(27, 73, 234, 1);
  color: white;
  align-items: center;
  justify-content: center;
`;

export const RejectButton = styled(Button)`
  background-color: #f44336;
  color: white;
  align-items: center;
  justify-content: center;
`;

export const ResumeButton = styled(Button)`
  border: 1px solid rgba(27, 73, 234, 1);
  background-color: rgba(255, 255, 255, 1);
  color: rgba(27, 73, 234, 1);
  align-items: center;
  justify-content: center;
`;

export const ProfileDetails = styled.div`
  text-align: left;

  p {
    margin: 5px 0;
  }

  strong {
    color: #555;
  }
`;

/* ------------------ Project Styles ------------------ */
export const ProjectCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
`;

export const ProjectInfo = styled.div`
  flex: 1;
`;

/* ------------------ Interview Styles ------------------ */
export const InterviewCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
`;

export const InterviewInfo = styled.div`
  flex: 1;
`;

export const PaginationSelectWrapper = styled.div`
  .ant-select-selector {
    height: 38px !important;
    border-radius: 8px !important;
    border: 1px solid #E5E7EB !important;
    background: #FFFFFF !important;
    padding: 0 10px !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    font-size: 13px !important;
    color: #374151 !important;
    font-weight: 400 !important;

    box-shadow: none !important;
    transition: all 0.15s ease !important;
  }

  &:hover .ant-select-selector {
    border-color: #D1D5DB !important;
  }

  .ant-select-focused .ant-select-selector {
    border-color: #4F46E5 !important;
  }

  .ant-select-selection-item {
    line-height: 34px !important;
  }

  .ant-select-arrow {
    color: #6B7280 !important;
  }
`;